module.exports = __webpack_public_path__ + "static/media/Leaf.f73b73a5.png";